import React, { useState } from "react";
import {
  Box,
  Typography,
  Container,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useTranslation } from "react-i18next";
import sesImg from "images/itservice/v2/ses.jpg";

export default () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      label: t("business.ses.development_lan.title"),
      content: t("business.ses.development_lan.content", {
        returnObjects: true,
      }),
    },
    {
      label: t("business.ses.Infrastructure.title"),
      content: t("business.ses.Infrastructure.content", {
        returnObjects: true,
      }),
    },
    {
      label: t("business.ses.Environment.title"),
      content: t("business.ses.Environment.content", { returnObjects: true }),
    },
  ];

  return (
    <Box sx={{ pb: 4 }} id="system-engineering">
      <Container maxWidth="lg">
        {/* Header Section with Image */}
        <Box sx={{ mb: 4 }}>
          <Box
            sx={{
              height: 200,
              position: "relative",
              mb: 3,
              borderRadius: 3,
              overflow: "hidden",
            }}
          >
            <Box
              component="img"
              src={sesImg}
              alt="System Engineering Services"
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                margin: "auto",
              }}
            />
            <Box
              sx={{
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
                background:
                  "linear-gradient(to top, rgba(0,0,0,0.7), transparent)",
                p: 2,
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  color: "white",
                  fontWeight: 700,
                }}
              >
                {t("business.ses.heading")}
              </Typography>
            </Box>
          </Box>

          <Typography
            variant="body1"
            sx={{
              color: "text.secondary",
              mb: 4,
              lineHeight: 1.6,
              fontSize: "0.8rem",
            }}
          >
            {t("business.ses.description")}
          </Typography>
        </Box>

        {/* Modern Tab Section */}
        <Box sx={{ mb: 2 }}>
          {/* Custom Tab Bar */}
          <Box
            sx={{
              display: "flex",
              gap: 1.5,
              px: 1,
              pb: 2,
              overflowX: "auto",
              "&::-webkit-scrollbar": {
                display: "none",
              },
              scrollbarWidth: "none",
            }}
          >
            {tabs.map((tab, index) => (
              <Box
                key={index}
                onClick={() => setActiveTab(index)}
                sx={{
                  py: 1,
                  px: 2,
                  borderRadius: 2,
                  bgcolor: activeTab === index ? "primary.main" : "grey.100",
                  color: activeTab === index ? "white" : "text.secondary",
                  fontWeight: 600,
                  fontSize: "0.875rem",
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  transition: "all 0.2s",
                  "&:active": {
                    transform: "scale(0.98)",
                  },
                }}
              >
                {tab.label}
              </Box>
            ))}
          </Box>

          {/* Content Section */}
          <Paper
            elevation={0}
            sx={{
              borderRadius: 3,
              bgcolor: "background.paper",
              border: "1px solid",
              borderColor: "divider",
            }}
          >
            {tabs.map((tab, index) => (
              <Box key={index} role="tabpanel" hidden={activeTab !== index}>
                {activeTab === index && (
                  <List sx={{ py: 1 }}>
                    {tab.content.map((item, itemIndex) => (
                      <ListItem key={itemIndex}>
                        <ListItemIcon sx={{ minWidth: 40 }}>
                          <CheckCircleIcon
                            sx={{
                              color: "primary.main",
                              fontSize: "1.25rem",
                            }}
                          />
                        </ListItemIcon>
                        <ListItemText
                          primary={item}
                          primaryTypographyProps={{
                            sx: {
                              fontSize: "0.875rem",
                              fontWeight: 500,
                            },
                          }}
                        />
                      </ListItem>
                    ))}
                  </List>
                )}
              </Box>
            ))}
          </Paper>
        </Box>
      </Container>
    </Box>
  );
};
